import { createAction } from '@reduxjs/toolkit';

import { replaceUpperCaseParams } from 'utils/string';
import { getFailurePayload } from 'modules/utils';

import * as actionTypes from './actionTypes';

/**
 * @return {{payload: import('./types').PostUnsubscribeAction}}
 */
export const postUnsubscribe = createAction(actionTypes.POST_CUSTOMER_LEADS_UNSUBSCRIBE, () => {
  const { pathname, search } = window.location;
  const params = replaceUpperCaseParams(search);

  return {
    payload: {
      request: {
        method: 'POST',
        url: `/fo${pathname}${params}`,
      },
    },
  };
});

/**
 * @param {import('./types').UnsubscribeData} unsubscribeData
 * @return {{payload: import('./types').PostUnsubscribeSuccessAction}}
 */
export const postUnsubscribeSuccess = createAction(
  actionTypes.POST_CUSTOMER_LEADS_UNSUBSCRIBE_SUCCESS,
  unsubscribeData => ({
    payload: unsubscribeData,
  })
);

/**
 * @param {string} message
 * @return {{payload: import('./types').PostUnsubscribeFailureAction}}
 */
export const postUnsubscribeFailure = createAction(
  actionTypes.POST_CUSTOMER_LEADS_UNSUBSCRIBE_FAILURE,
  getFailurePayload
);
